// actions.js
import * as actionTypes from './actionsTypes';

export const setValueReservationEnCours = (value) => ({
  type: actionTypes.SET_VALUE_RESERVATION_EN_COURS,
  payload: value,
});

export const setStatutReservationEnCours = (statut) => ({
  type: actionTypes.SET_STATUT_RESERVATION_EN_COURS,
  payload: statut,
});

export const setAnneeReservationEnCours = (annee) => ({
  type: actionTypes.SET_ANNEE_RESERVATION_EN_COURS,
  payload: annee,
});

export const setCurrentPageReservationEnCours = (page) => ({
  type: actionTypes.SET_CURRENT_PAGE_RESERVATION_EN_COURS,
  payload: page,
});

export const setOrderReservationEnCours = (order) => ({
  type: actionTypes.SET_ORDER_RESERVATION_EN_COURS,
  payload: order,
});

export const setSortFieldReservationEnCours = (field) => ({
  type: actionTypes.SET_SORT_FIELD_RESERVATION_EN_COURS,
  payload: field,
});
  
  
  

  
  